export const contentTileLinkStyles = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'stretch',
	gap: '1rem',
	padding: '0',
	backgroundColor: '#E0EDDE',
	borderRadius: '1rem',
	textDecoration: 'none',
	pr: '1rem',
	minHeight: '6.5rem',
};

export const contentTileImageStyles = {
	flex: 1,
	width: '4.5rem',
	position: 'relative',
	overflow: 'hidden',
	borderRadius: '0.5rem 0 0 0.5rem',
};

// absolute positioning takes the image out of flow so its intrinsic aspect ratio can never grow the tile
export const contentTileImageAssetStyles = {
	position: 'absolute',
	inset: 0,
	width: '100%',
	height: '100%',
	objectFit: 'cover',
};

export const contentTileTextStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '0.25rem',
	flex: 1,
	minWidth: 0,
	py: '2rem',
};

export const contentTileTitleStyles = {
	color: 'text.secondary',
};

export const contentTileDescriptionStyles = {
	color: 'text.secondary',
};

export const contentTileArrowIconStyles = {
	flexShrink: 0,
	alignSelf: 'center',
};
